import * as React from "react";

interface AuthErrorMessageProps {
  error: string;
}

export const AuthErrorMessage: React.FC<AuthErrorMessageProps> = ({
  error,
}) => {
  if (!error) return null;

  return (
    <small className="p-error block mt-2">
      <i className="pi pi-exclamation-circle mr-2" />
      {error}
    </small>
  );
};

export default AuthErrorMessage;
